<div class="email-feed-loader-wrapper">
  <ngx-skeleton-loader [theme]="getThemeConfig({ width: '70%' })"></ngx-skeleton-loader>
  <ngx-skeleton-loader [theme]="getThemeConfig({ width: '40%' })"></ngx-skeleton-loader>
  <ngx-skeleton-loader [theme]="getThemeConfig({ width: '60%' })"></ngx-skeleton-loader>
  <ngx-skeleton-loader [theme]="getThemeConfig({ width: '90%' })"></ngx-skeleton-loader>
</div>
